import styled from 'styled-components';

export const Center = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
`;

export const Left = styled.div`
    display: flex;
    justify-content: left;
    flex-direction: column;
    text-align: left;
`;

export const Right = styled.div`
    display: flex;
    justify-content: right;
    flex-direction: column;
    text-align: right;
`;
